<template>
  <div>
    <b-btn
      v-b-tooltip.hover
      variant="none"
      title="Histórico"
      class="btn btn-sm btn-none px-50 py-0"
      @click="show()"
    >
      <font-awesome-icon
        icon="fa-solid fa-list"
        class="text-primary"
      />
    </b-btn>

    <!-- "scrollable" mantido só pelo layout flex que aplica ao modal-content
         (ajuda o modal-body a esticar); o scroll em si vem do CSS abaixo,
         já que o overflow:hidden nativo do "scrollable" foi neutralizado
         de propósito (ver comentário no bloco <style>) -->
    <b-modal
      ref="modalHistorico"
      button-size="sm"
      lazy
      no-stacking
      ok-only
      ok-title="Ok"
      size="xl"
      centered
      scrollable
      dialog-class="modal-historico-envio"
      cancel-title=""
      :cancel-disabled="true"
      cancel-variant="false"
    >
      <div slot="modal-title">
        <h5>Histórico - {{ tituloRotina }}</h5>
        <fieldset class="font-weight-bold text-muted">
          Alterações de configuração e envios realizados
        </fieldset>
      </div>

      <b-tabs lazy>
        <!-- Aba Alteração -->
        <b-tab title="Alteração">
          <b-table
            ref="tabelaAlteracao"
            :items="logsProvider"
            :fields="camposAlteracao"
            :current-page="currentPageAlteracao"
            :per-page="perPageAlteracao"
            responsive
            small
            show-empty
            empty-text="Nenhuma alteração registrada"
          >
            <template #table-busy>
              <div class="text-center py-3">
                <b-spinner small />
                Carregando...
              </div>
            </template>
            <template #cell(data)="{ item }">
              {{ formatarData(item.data) }}
            </template>
            <template #cell(tipoAcao)="{ item }">
              <b-badge :variant="variantAcao(item.tipoAcao)">
                {{ labelAcao(item.tipoAcao) }}
              </b-badge>
            </template>
            <template #cell(de)="{ item }">
              <span v-if="item.tipoAcao === 0">{{ item.valorAnterior }}</span>
              <span v-else-if="item.tipoAcao === 2">
                {{ item.empresaCadastroFederal || `ID: ${item.empresaId}` }}
              </span>
            </template>
            <template #cell(para)="{ item }">
              <span v-if="item.tipoAcao === 0">{{ item.valorNovo }}</span>
              <span v-else-if="item.tipoAcao === 1">
                {{ item.empresaCadastroFederal || `ID: ${item.empresaId}` }}
              </span>
            </template>
          </b-table>
          <b-pagination
            v-if="totalRowsAlteracao > perPageAlteracao"
            v-model="currentPageAlteracao"
            :total-rows="totalRowsAlteracao"
            :per-page="perPageAlteracao"
            align="center"
            size="sm"
            class="my-0 mt-1"
          />
        </b-tab>

        <!-- Aba Histórico de envio -->
        <b-tab title="Histórico de envio">
          <b-table
            ref="tabelaEnvio"
            :items="enviosProvider"
            :fields="camposEnvio"
            :current-page="currentPageEnvio"
            :per-page="perPageEnvio"
            responsive
            small
            show-empty
            empty-text="Nenhum envio registrado"
          >
            <template #table-busy>
              <div class="text-center py-3">
                <b-spinner small />
                Carregando...
              </div>
            </template>
            <template #cell(data)="{ item }">
              {{ formatarData(item.data) }}
            </template>
            <template #cell(empresaRazaoSocial)="{ item }">
              <span
                v-if="item.empresaRazaoSocial"
                v-b-tooltip.hover
                :title="item.empresaRazaoSocial"
                style="cursor: default;"
              >
                {{ item.empresaRazaoSocial.substring(0, 20) }}{{ item.empresaRazaoSocial.length > 20 ? '…' : '' }}
              </span>
            </template>
            <template #cell(status)="{ item }">
              <b-badge :variant="variantStatus(item.status)">
                {{ labelStatus(item.status) }}
              </b-badge>
            </template>
            <template #cell(erroMensagem)="{ item }">
              <span
                v-if="item.erroMensagem"
                v-b-tooltip.hover
                :title="item.erroMensagem"
                class="text-danger"
                style="cursor: pointer;"
              >
                <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              </span>
            </template>
          </b-table>
          <b-pagination
            v-if="totalRowsEnvio > perPageEnvio"
            v-model="currentPageEnvio"
            :total-rows="totalRowsEnvio"
            :per-page="perPageEnvio"
            align="center"
            size="sm"
            class="my-0 mt-1"
          />
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import api from '../services/api'

export default {
  name: 'HistoricoEnvioAutomatico',
  props: {
    tipoRotina: {
      type: Number,
      required: true,
    },
    tituloRotina: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentPageAlteracao: 1,
      perPageAlteracao: 50,
      totalRowsAlteracao: 0,
      currentPageEnvio: 1,
      perPageEnvio: 50,
      totalRowsEnvio: 0,
      camposAlteracao: [
        { key: 'data', label: 'Data/Hora', thStyle: { width: '180px' } },
        { key: 'usuario', label: 'Usuário' },
        { key: 'tipoAcao', label: 'Ação', thStyle: { width: '160px' } },
        { key: 'de', label: 'De' },
        { key: 'para', label: 'Para' },
      ],
      camposEnvio: [
        { key: 'data', label: 'Data/Hora', thStyle: { width: '180px' } },
        { key: 'empresaCadastroFederal', label: 'CNPJ/CPF', thStyle: { width: '160px' } },
        { key: 'empresaRazaoSocial', label: 'Empresa', thStyle: { width: '160px' } },
        { key: 'status', label: 'Status', thStyle: { width: '120px' } },
        { key: 'destinatario', label: 'Destinatário' },
        { key: 'erroMensagem', label: '', thStyle: { width: '40px' } },
      ],
    }
  },
  methods: {
    show() {
      this.currentPageAlteracao = 1
      this.currentPageEnvio = 1
      this.$refs.modalHistorico.show()
      if (this.$refs.tabelaAlteracao) this.$refs.tabelaAlteracao.refresh()
      if (this.$refs.tabelaEnvio) this.$refs.tabelaEnvio.refresh()
    },
    logsProvider(ctx) {
      return api.getLogsPaged(this.tipoRotina, ctx.currentPage, ctx.perPage)
        .then(payload => {
          this.totalRowsAlteracao = payload.data.total || 0
          return payload.data.valores || []
        })
        .catch(() => {
          this.$erro('Não foi possível carregar o histórico de alterações.')
          this.totalRowsAlteracao = 0
          return []
        })
    },
    enviosProvider(ctx) {
      return api.getHistoricoEnviosPaged(this.tipoRotina, ctx.currentPage, ctx.perPage)
        .then(payload => {
          this.totalRowsEnvio = payload.data.total || 0
          return payload.data.valores || []
        })
        .catch(() => {
          this.$erro('Não foi possível carregar o histórico de envios.')
          this.totalRowsEnvio = 0
          return []
        })
    },
    formatarData(data) {
      if (!data) return ''
      return new Date(data).toLocaleString('pt-BR')
    },
    labelAcao(tipoAcao) {
      const labels = { 0: 'Config. alterada', 1: 'Empresa adicionada', 2: 'Empresa removida' }
      return labels[tipoAcao] ?? tipoAcao
    },
    variantAcao(tipoAcao) {
      const variants = { 0: 'light-primary', 1: 'light-success', 2: 'light-danger' }
      return variants[tipoAcao] ?? 'light-secondary'
    },
    labelStatus(status) {
      const labels = { 0: 'Pendente', 1: 'Enviado', 2: 'Erro' }
      return labels[status] ?? status
    },
    variantStatus(status) {
      const variants = { 0: 'light-warning', 1: 'light-success', 2: 'light-danger' }
      return variants[status] ?? 'light-secondary'
    },
  },
}
</script>

<style>
.modal-historico-envio.modal-dialog {
  max-width: 960px;
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
  margin-left: auto;
  margin-right: auto;
}

/*
 * O tema global força ".modal .modal-content { overflow: visible; }" (ver
 * src/@core/scss/base/bootstrap-extended/_modal.scss) — necessário para o
 * botão de fechar (que "escapa" da borda via transform) não ficar cortado.
 * Por isso o limite de altura + scroll vai só no modal-body (que tem seu
 * próprio overflow, independente do overflow do modal-content pai), em vez
 * de forçar overflow:hidden no modal-content inteiro — isso manteria a
 * modal dentro do viewport mas cortaria o "X" nos cantos arredondados.
 */
.modal-historico-envio .modal-body {
  max-height: calc(100vh - 14rem);
  overflow-y: auto;
}
</style>
